import * as Yup from 'yup'

export const leadAdValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required'),
  lead_ad_type_id: Yup.object().required('type is required').nullable(),
  project_id: Yup.object().required('project is required').nullable()
});